import { motion } from "framer-motion";
import { Heart, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

const DonateNow = () => {
  return (
    <div className="min-h-screen bg-[#F8F9FA] py-8 md:py-12 relative" data-testid="donate-now-page">
      {/* Coming Soon Overlay */}
      <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="text-center px-4"
        >
          <Card className="shadow-2xl border-t-4 border-t-[#e74c3c] max-w-md mx-auto">
            <CardContent className="p-8 md:p-12">
              <div className="w-20 h-20 bg-[#e74c3c]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Clock className="w-10 h-10 text-[#e74c3c]" />
              </div>
              
              <h1 className="text-3xl md:text-4xl font-bold text-[#2c3e50] font-['Manrope'] mb-4">
                Coming Soon
              </h1>
              
              <p className="text-lg text-[#546e7a] mb-6">
                Our donation portal is currently being set up. We'll be ready to accept donations for <strong>Giant-Tree Foundation</strong> very soon!
              </p>
              
              <div className="bg-slate-50 rounded-lg p-4 mb-6">
                <p className="text-sm text-[#546e7a]">
                  Want to be notified when donations go live?
                </p>
                <p className="text-[#2c3e50] font-semibold mt-1">
                  Email us at <a href="mailto:helloelderra@gmail.com" className="text-[#e74c3c] hover:underline">helloelderra@gmail.com</a>
                </p>
              </div>
              
              <Link to="/">
                <Button className="w-full bg-[#2c3e50] hover:bg-[#1a252f] text-white text-lg font-bold py-4 rounded-lg">
                  <Heart className="w-5 h-5 mr-2" />
                  Return to Home
                </Button>
              </Link>
            </CardContent>
          </Card>
        </motion.div>
      </div>

      {/* Blurred Background Content */}
      <div className="max-w-4xl mx-auto px-4 filter blur-md pointer-events-none select-none">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#e74c3c]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Heart className="w-8 h-8 text-[#e74c3c]" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-[#2c3e50] font-['Manrope'] mb-2">
            Donate Now
          </h1>
          <p className="text-lg text-[#546e7a]">
            Support our mission to protect senior citizens
          </p>
        </div>

        {/* Placeholder Cards */}
        <div className="grid grid-cols-3 gap-4 mb-8">
          {[1, 2, 3].map((i) => (
            <Card key={i}>
              <CardContent className="p-4 text-center">
                <div className="w-8 h-8 bg-slate-200 rounded-full mx-auto mb-2" />
                <div className="h-6 bg-slate-200 rounded mb-1" />
                <div className="h-4 bg-slate-100 rounded" />
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="shadow-lg">
          <CardContent className="p-8">
            <div className="space-y-6">
              <div className="h-8 bg-slate-200 rounded w-1/3" />
              <div className="grid grid-cols-3 gap-4">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div key={i} className="h-24 bg-slate-100 rounded-lg" />
                ))}
              </div>
              <div className="h-12 bg-slate-200 rounded" />
              <div className="h-12 bg-slate-200 rounded" />
              <div className="h-14 bg-[#e74c3c]/30 rounded-lg" />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DonateNow;
